import React, { useEffect, useState } from "react";
import { FaEdit, FaTrash } from "react-icons/fa";
import { IoCameraOutline } from "react-icons/io5";
import { BsThreeDots } from "react-icons/bs";
import { LuCamera } from "react-icons/lu";
import { useNavigate } from "react-router-dom";
import {
  deleteEventApi,
  EventListUseCaseApi,
  UseCaseeventListApi,
  UsecaseEvnetById,
} from "../../api/api";
import { toast } from "react-toastify";
import { SkeletonCard } from "../../context/Customfunction";
import axios from "axios";
import { PulseLoader } from "react-spinners";
import { useSelector } from "react-redux";

function UseCaseEvent() {
  const [event, setEvent] = useState([]);
  console.log("event", event);
  const [loading, setLoading] = useState(false);
  const [useCase, setUseCase] = useState([]);
  console.log("useCase", useCase);
  const navigate = useNavigate();
  const [useCaseId, setUseCaseId] = useState("");
  const [openMenuId, setOpenMenuId] = useState(null);
  const [syncing, setSyncing] = useState(false);
  const { user_id, organization_id } = useSelector(
    (state) => state?.authUser?.data?.data
  );
  const fetchEvents = async () => {
    setLoading(true);
    try {
      const data = await EventListUseCaseApi(user_id, organization_id);
      console.log("gdgasd", data);
      if (data?.data?.status === true) {
        setEvent(data?.data?.data);
      }
    } catch (error) {
      console.error("Error fetching events:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchUseCase = async () => {
    try {
      const data = await UseCaseeventListApi("", user_id, organization_id);
      if (data?.data?.status === true) {
        setUseCase(data?.data?.data);
      }
    } catch (error) {
      console.error("Error fetching use cases:", error);
    }
  };

  useEffect(() => {
    fetchEvents();
    fetchUseCase();
  }, []);

  const fetchEvent = async (id) => {
    try {
      const data = await UsecaseEvnetById(id);

      if (data?.data?.status === true) {
        setEvent(data?.data?.data);
      }
    } catch (error) {
      console.error("Error fetching event by ID:", error);
    }
  };

  const handleEdit = (eventId) => {
    // Navigate or open modal for editing
    navigate(`/edit-event/${eventId}`);
  };

  const handleDelete = async (eventId) => {
    try {
      const data = await deleteEventApi(eventId);
      if (data) {
        toast("Event deleted!!");
        fetchEvents();
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  const handleSync = async () => {
    setSyncing(true);
    try {
      const data = await axios.get(
        "https://visionemptrack.greymatterz.com/queuewaiting/sync-events"
      );

      const sync = await axios.get(
        "http://192.168.20.24:8016/start_jacket_feed"
      );
    } catch (error) {
      console.log("error", error);
    } finally {
      setSyncing(false);
    }
  };

  return (
    <div>
      <aside className="mainSection">
        <div className="mb-5 pb-5 border-bottom">
          <div className="topEventFilter py-3 px-4">
            <div className="formField">
              <span className="selectIcon">
                <IoCameraOutline size={18} />
              </span>
              <select
                className="form-select"
                value={useCaseId}
                onChange={(e) => {
                  const id = e.target.value;
                  setUseCaseId(id);
                  if (id && id !== "UseCase") {
                    fetchEvent(id);
                  }
                }}
              >
                <option>UseCase</option>
                {useCase?.map((ele) => (
                  <option key={ele._id} value={ele._id}>
                    {ele.usecase_name}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="p-4">
            <div className="d-flex justify-content-between align-items-center">
              <h3 className="m-0 font24">
                All Events ({event?.length === 0 ? 4 : ""})
              </h3>

              <div className="d-flex align-items-center gap-3">
                {syncing ? (
                  <button className="mainBlue3 p-2">
                    <PulseLoader color="#fff" />
                  </button>
                ) : (
                  <button onClick={handleSync} className="mainBlue3 p-2">
                    Sync
                  </button>
                )}
                <button className="transParent3 p-2">Select</button>
                <button
                  onClick={() => {
                    localStorage.removeItem("Camera_ids");
                    navigate("/create-new-event");
                  }}
                  className="mainBlue3 p-2"
                >
                  + New Event
                </button>
              </div>
            </div>
          </div>

          <div className="px-4">
            <div className="allEventsItems">
              {loading
                ? // Show 4 skeletons
                  Array.from({ length: 4 }).map((_, index) => (
                    <SkeletonCard key={index} />
                  ))
                : event &&
                  event?.events?.map((ele) => (
                    <div
                      key={ele._id}
                      className="itemsBox"
                      onClick={(e) => {
                        const selection = window.getSelection();
                        if (!selection || selection.toString().length === 0) {
                          navigate(
                            `/usecase-events-logs/${
                              ele?.cameras[0]?.camera_id
                            }/${encodeURIComponent(ele?.event_type_name)}`
                          );
                        }
                      }}
                    >
                      <div className="d-flex justify-content-between align-items-center">
                        <span className="ident">{ele?.event_type_name}</span>

                        <div
                          className="position-relative"
                          onClick={(e) => {
                            e.stopPropagation();
                            setOpenMenuId(
                              openMenuId === ele._id ? null : ele._id
                            );
                          }}
                        >
                          <BsThreeDots
                            size={24}
                            style={{ cursor: "pointer" }}
                          />

                          {openMenuId === ele._id && (
                            <div
                              className="dropdown-menu show p-2"
                              style={{
                                position: "absolute",
                                right: 0,
                                top: "30px",
                                zIndex: 100,
                                minWidth: "120px",
                                boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
                                backgroundColor: "#fff",
                                borderRadius: "4px",
                              }}
                            >
                              <div
                                className="dropdown-item d-flex align-items-center gap-2"
                                style={{ cursor: "pointer" }}
                                onClick={() => handleEdit(ele._id)}
                              >
                                <FaEdit /> Edit
                              </div>
                              <div
                                className="dropdown-item d-flex align-items-center gap-2"
                                style={{ cursor: "pointer" }}
                                onClick={() => handleDelete(ele._id)}
                              >
                                <FaTrash /> Delete
                              </div>
                            </div>
                          )}
                        </div>
                      </div>

                      <h3 className="my-3">Event Name - {ele?.event_name}</h3>

                      <p className="contIcon mb-2">
                        <span className="selectIcon">
                          <LuCamera size={18} />
                        </span>
                        {ele?.cameras[0]?.camera_name}
                      </p>
                    </div>
                  ))}
            </div>
          </div>
        </div>
      </aside>
    </div>
  );
}

export default UseCaseEvent;
